
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class CampsiteDetailBackToTopContainer extends Vue {
  showBackToTopButton = false
  backToTopVisibilityChanged(isVisible: boolean) {
    this.showBackToTopButton = !isVisible
  }
}
